import React from "react";
import { Chip, Grid, Typography } from "@mui/material";
import Slider from "@mui/material/Slider";
import useTypeRageSelect, { FULL_RANGE } from "./Hooks/useTypeRageSelect";

const TypeRageSelect = ({ label, updateCourseState }) => {
  const { handleDeleteChip, handleAgeChange, ageRange } = useTypeRageSelect({
    label,
    updateCourseState,
  });

  return (
    <Grid container className="date_range_filter" alignItems={"center"}>
      <Grid item sx={{ minWidth: "220px" }} marginRight={"20px"}>
        <Typography variant="subtitle1">{"Filter"}</Typography>
        <Slider
          className="range_slider"
          value={ageRange}
          onChange={handleAgeChange}
          valueLabelDisplay="auto"
          min={FULL_RANGE[0]}
          max={FULL_RANGE[1]}
          step={1}
        />
      </Grid>
      <Grid item>
        <div style={{ marginTop: "25px", marginLeft: "20px" }}>
          {(ageRange[0] !== FULL_RANGE[0] || ageRange[1] !== FULL_RANGE[1]) && (
            <Chip
              label={`${ageRange[0]}-${ageRange[1]}`}
              onDelete={handleDeleteChip}
              style={{
                marginRight: "7px",
                marginBottom: "5px",
                borderRadius: "5px",
              }}
            />
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default TypeRageSelect;
